import { createAction } from 'redux-actions';
import {
    SET_HISTORYVALUE,
    SET_HISTOERYRESULT
} from '../constants/actionTypes';
import { doGet, doPost } from '../utils/AjaxRequests'
import _ from 'lodash'
import { apiPrefixUrl } from '../utils/connection'
import { format, parse, isValid } from 'date-fns'
import Swal from 'sweetalert2'
import { history } from '../router/history'

export const setHistoryValue = createAction(SET_HISTORYVALUE)
export const setHistoryResult = createAction(SET_HISTOERYRESULT)

export const searchHistory = () => {
    return (dispatch, getState) => {
        const search = (getState().getIn(["reserveHistory", "search"])).toJS()

        if (!search.PAT_IDNO  || !search.TEL_MOBILE) {
            Swal.fire("尚有欄位未填寫", "", "error")
            return
        }

        dispatch(setHistoryValue({
            page: "search",
            field: "loading",
            value: true
        }))
        doPost(apiPrefixUrl, {
            // "api": "BookingFind4Patient",
            // "PAT_IDNO": search.PAT_IDNO,
            // "TICKET_NO": search.TICKET_NO,
            // "TEL_MOBILE": search.TEL_MOBILE,
            // "USER_ID":"PATIENT"
            "api": "BookingFind4PatientVACC",
            "SPNO": "",
            "USER_ID": "PATIENT",
            "PAT_IDNO": search.PAT_IDNO,
            "TEL_MOBILE": search.TEL_MOBILE,
            "TICKET_NO": search.TICKET_NO
        })
            .then((data) => {
                if (data.status && data.data) {
                    dispatch(setHistoryResult({ value: data.data }))
                    history.push('/historyResult')
                    dispatch(setHistoryValue({
                        page: "search",
                        field: "loading",
                        value: false
                    }))
                } else {
                    throw Error(data.message)
                }
            })
            .catch((e) => {
                Swal.fire(e.message, "", "error")
                dispatch(setHistoryValue({
                    page: "search",
                    field: "loading",
                    value: false
                }))
            })

    }
}

export const cancelReserve = (idx) => {
    return (dispatch, getState) => {
        const result = (getState().getIn(["reserveHistory", "result"])).toJS()

        Swal.fire({
            title: '確定取消預約？',
            // showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "確定",
            cancelButtonText: "取消"
            // denyButtonText: `Don't save`,
        }).then((swalResult) => {
            /* Read more about isConfirmed, isDenied below */
            if (swalResult.isConfirmed) {
                doPost(apiPrefixUrl, {
                    "api":"BookingCancel4PatientVACC",
                    "SPNO":"",
                    "PAT_IDNO": result[idx].PAT_IDNO,
                    "TICKET_NO": result[idx].TICKET_NO,
                    "TEL_MOBILE": result[idx].TEL_MOBILE,
                    "TOKEN": result[idx].TOKEN,
                    "USER_ID": "PATIENT"
                }).then((data) => {
                    if (data.status && data.data) {
                        Swal.fire(data.message, "", "success")
                        if(result.length === 1){
                            history.push('/search')
                        }                        
                    } else {
                        Swal.fire(data.message, "", "error")
                    }
                })
            }
        })


    }
}